import { render, staticRenderFns } from "./ZDivider.vue?vue&type=template&id=0a5cf1ab&"
import script from "./ZDivider.vue?vue&type=script&lang=ts&"
export * from "./ZDivider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports